module.exports = __webpack_public_path__ + "static/media/ridr-logo-2017.2e42c74e.jpg";